export const LOAN_PRODUCT_NAME_DUPLICATE_MESSAGE =
  'Loan Product Name already exists.';

export function normalizeLoanProductName(value) {
  return String(value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();
}

export function normalizeLoanProductNameForSave(value) {
  return String(value || '')
    .trim()
    .replace(/\s+/g, ' ');
}

export function hasDuplicateLoanProductName(loanProducts, loanProductName, currentId) {
  const normalizedName = normalizeLoanProductName(loanProductName);

  if (!normalizedName) return false;

  return (loanProducts || []).some((product) => {
    if (!product) return false;
    if (
      product.id != null &&
      currentId != null &&
      String(product.id) === String(currentId)
    ) {
      return false;
    }

    return normalizeLoanProductName(product.loanProductName) === normalizedName;
  });
}

export function assertUniqueLoanProductName(loanProducts, payload) {
  if (
    hasDuplicateLoanProductName(
      loanProducts,
      payload?.loanProductName,
      payload?.id
    )
  ) {
    throw new Error(LOAN_PRODUCT_NAME_DUPLICATE_MESSAGE);
  }
}
